
import { HIDE_MENU } from '../Actions/types'
import { SHOW_MENU } from '../Actions/types'

const initialState = {
    showMenu: "SideMenu"
}

export default function (state = initialState, action) {
    switch(action.type) {
        case HIDE_MENU: 
        console.log('reducer test');
            return {
             ...state,
               showMenu: action.payload
            };
            case SHOW_MENU: 
            console.log('reducer test');
                return {
                 ...state,
                 showMenu: action.payload
                };
        default: 
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/Reducers/MyHavenSideMenuReducer.js